import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const AccommodationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={e => e.stopPropagation()}
          className="bg-white rounded-2xl p-8 max-w-md w-full relative"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <FaTimes />
          </button>

          <h3 className="text-2xl font-cursive text-[#D4AF37] mb-6 text-center">
            Reservar Estadía en Hoteles
          </h3>

          <div className="space-y-6">
            <div className="space-y-4">
              <h4 className="font-serif text-lg font-semibold text-gray-800">Tarifas:</h4>
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="font-serif text-gray-700">Noche por persona</span>
                  <span className="font-serif font-semibold text-[#D4AF37]">-</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-serif text-gray-700">Late check-out (hasta 18hs)</span>
                  <span className="font-serif font-semibold text-[#D4AF37]">-</span>
                </div>
                <p className="text-xs italic text-[#C5A028] mt-2">
                  * Ya no quedas habitaciones disponibles para el 29 de Noviembre.
                </p>
              </div>
            </div>
          </div>
          <div>
            <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <p className="font-serif text-gray-700 mb-3">
                <span className="font-semibold">Importante:</span> La estadía en Hotel Nawan ya no se encuentra disponible
              </p>
              <p className="font-serif text-gray-700 mb-3">
                En caso de no haber disponibilidad, recomendamos reservar en:
              </p>
              <ul className="list-disc pl-5 mb-3 font-serif text-gray-700">
                <li>Hotel Napoleon</li>
                <li>Hotel Jesús María</li>
              </ul>
              <p className="font-serif text-gray-700 text-sm italic">
                Ambos hoteles contarán con servicio de traslado en trafic hasta el evento, ubicado a solo 10 minutos de distancia. En caso de reservar en estos lugares, por favor notifícanos para la organización de las trafics.
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AccommodationModal; 